import type {paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

type UpdateResidenceOperation = paths['/executor_web/identification/residence']['patch'];

export type UpdateResidenceRequest = NonNullable<
	NonNullable<UpdateResidenceOperation['requestBody']>['content']['application/json']
>;
export type UpdateResidenceResponse =
	UpdateResidenceOperation['responses'][200]['content']['application/json'];

/** PATCH `/executor_web/identification/residence` — см. `paths['/executor_web/identification/residence']` в auth swagger */
export function updateResidence(request: UpdateResidenceRequest, signal?: AbortSignal) {
	return axiosInstance.patch<UpdateResidenceResponse>('identification/residence', request, {signal});
}
